define('models/pages/news/news-view',[
    'underscore',
    'lib/utils',
    'models/base/model',
    'models/base/collection'
], function(_, utils, Model, Collection) {
    'use strict';

    var NewsViewModel = Model.extend({
        urlPath: '/page/news/item',

        defaults: {
            ID: (new Date()).getTime(),
            tags: new Collection(),
            NewsDate: null,
            Header: '',
            ShortDescription: '',
            PhotoUrl: null,
            Content: '',
            Positive: 0,
            Negative: 0,
            Readed: 0,
            Value: 0
        },

        constructor: function() {
            Model.apply(this, arguments);
        },

        //catch image url and add apiUrl to header
        //?type=content-editor-image
        _preprocessNewsContentImage: function(content){

            return _.map(content.split('?type=content-editor-image'), function(parts){
                var _cparts = parts.split('src="/images/news');

                if (_cparts.length && _cparts.length>1) {
                    parts = _cparts[0] + 'src="' + utils.getApiRoot() + '/images/news' + _cparts[1];
                }

                return parts;
            }).join('');

        },

        parse: function(data) {
            data.tags = (data.tags || '').split(',');
            data.Content = this._preprocessNewsContentImage(data.Content || '');
            return data;
        },

        urlParams: function() {
            var params = Model.prototype.urlParams.apply(this, arguments);
            params.newsId = this.get('ID');
            return params;
        },
    });


    return NewsViewModel;
});
